import { DotLegalDialog, DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { Alert, Box } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import { useSendTaskReminderDialog } from "./SendTaskReminderDialog.hooks";

export interface SendTaskReminderDialogProps {
    taskId: string;
    onCloseDialog: () => void;
}

function SendTaskReminderDialog(props: SendTaskReminderDialogProps) {
    const { translateString } = useTranslation();
    const { recipientIds, recipientOptions, isLoading, isSending, setRecipientIds, onSendClick } = useSendTaskReminderDialog(props);

    return (
        <DotLegalDialog
            size="sm"
            open
            header={translateString("sendReminder")}
            buttonOkText={translateString("send")}
            okButtonDisabled={recipientIds.length === 0}
            onOkClick={onSendClick}
            onDialogClose={props.onCloseDialog}
            isLoading={isLoading}
            inProgress={isSending}
        >
            <Box display="flex" gap={1} flexDirection={"column"}>
                <Alert severity={"info"}>{translateString("sendTaskReminderDialogDescription")}</Alert>

                <DotLegalMultiSelect
                    options={recipientOptions}
                    chosenOptions={recipientIds}
                    onChange={(recipients) => setRecipientIds(recipients)}
                    label={translateString("recipients")}
                    placeholder={translateString("recipients")}
                    noOptionsLabel={translateString("noOptions")}
                />
            </Box>
        </DotLegalDialog>
    );
}

export default SendTaskReminderDialog;
